/**
 * changelog.js — Données statiques du journal des mises à jour SkyApp
 *
 * Pour ajouter une nouvelle version :
 * 1. Copiez un bloc existant en haut du tableau
 * 2. Mettez à jour la version, la date et les entrées
 * 3. Les catégories vides peuvent être laissées comme tableaux vides []
 *
 * Ordre : du plus récent au plus ancien.
 */

const changelog = [
  {
    version: "0.9.1",
    date: "2026-11-02",
    nouveautes: [
      "Politique de mot de passe renforcée (8 caractères min., majuscule, minuscule, chiffre, caractère spécial) avec indicateur de force affiché en temps réel, appliquée à l'inscription, l'acceptation d'invitation et la réinitialisation de mot de passe",
      "Message clair affiché à la connexion lorsqu'un compte a été désactivé par un administrateur"
    ],
    ameliorations: [
      "Remplacement des fenêtres de confirmation du navigateur par des fenêtres de confirmation intégrées au design de l'application (suppression, désactivation de compte, annulation d'invitation, etc.)",
      "Réinitialisation de mot de passe désormais validée côté serveur, et non plus uniquement côté navigateur"
    ],
    corrections: [
      "Impossible de créer deux comptes avec la même adresse e-mail : message d'erreur clair affiché au lieu d'une erreur serveur"
    ],
    enCours: []
  },
  {
    version: "0.9.0",
    date: "2026-09-06",
    nouveautes: [
      "Nouveau thème SkyApp appliqué aux pages Matériel et Gestion d'équipe",
      "Détails enrichis d'une mission directement depuis le planning (chantier, équipe, horaires)",
      "Discussions et photos directement rattachées à une mission ou un chantier",
      "Cycle de validation des comptes-rendus de fin de chantier : demande de correction, renvoi par le technicien puis validation définitive"
    ],
    ameliorations: [
      "Adresse du chantier désormais visible directement sur les devis",
      "Filtrage des missions du chef d'équipe par chantier plus fiable dans le planning",
      "Un compte-rendu validé est désormais définitivement verrouillé et ne peut plus être modifié",
      "Déconnexion automatique après 10 minutes d'inactivité désormais effective même après fermeture du navigateur ou mise en veille du poste"
    ],
    corrections: [
      "Correction d'un décalage d'horaires (fuseau) sur certaines missions du planning"
    ],
    enCours: []
  },
  {
    version: "0.8.0",
    date: "2026-08-14",
    nouveautes: [
      "Refonte complète de la facture PDF : échéance de paiement, mention du médiateur, pagination des CGV",
      "Suivi de l'état de paiement des factures",
      "Nouveau thème SkyApp appliqué au formulaire de recherche"
    ],
    ameliorations: [
      "Gestion de la TVA en autoliquidation et des conditions de devis (acompte, durée de validité)",
      "Informations supplémentaires affichées sur les cartes chantiers",
      "Filtres affinés sur les recherches d'infiltration",
      "Retrait des invitations reçues cassées de la liste des invitations"
    ],
    corrections: [
      "Correction du logo affiché dans les e-mails envoyés",
      "Correction d'une erreur 500 lors de l'upload de photo",
      "Correction d'une surconsommation mémoire (OOM) sur le serveur : compression des photos et allègement des devis renvoyés par l'API",
      "Correction d'une erreur au chargement de la liste des utilisateurs liée aux invitations"
    ],
    enCours: []
  },
  {
    version: "0.7.0",
    date: "2026-07-30",
    nouveautes: [
      "Confirmation d'adresse e-mail obligatoire à l'inscription : un e-mail de confirmation est envoyé automatiquement et la connexion reste bloquée tant que l'adresse n'est pas validée",
      "Nouvelle page dédiée pour suivre l'état de sa confirmation et renvoyer l'e-mail en un clic",
      "Page de confirmation après clic sur le lien reçu par e-mail, avec message clair en cas de lien invalide ou expiré"
    ],
    ameliorations: [
      "Message de connexion plus clair lorsque l'adresse e-mail n'est pas encore confirmée, avec bouton pour renvoyer l'e-mail directement depuis l'écran de connexion",
      "Protection renforcée contre les abus sur le renvoi d'e-mail de confirmation (délai minimum entre deux envois, quelle que soit l'adresse saisie)"
    ],
    corrections: [],
    enCours: []
  },
  {
    version: "0.6.0",
    date: "2026-07-06",
    nouveautes: [
      "Comptes-rendus de chantier (bureau) : cartes redessinées aux couleurs SkyApp avec boutons Modifier, Voir et Télécharger PDF directement sur chaque carte",
      "Modification d'un compte-rendu par le bureau : nouveau formulaire d'édition (travaux, matériaux, durée, observations, problèmes) sans recharger la page",
      "Arrière-plan dégradé SkyApp (bleu/violet/orange) appliqué à toutes les pages de l'application (technicien, bureau, sélecteur d'interface, dossiers)",
      "Page de sélection d'interface (Technicien / Bureau) redessinée avec les couleurs et le dégradé SkyApp"
    ],
    ameliorations: [
      "Cartes chantier de la vue Bureau : barre de couleur SkyApp en haut de chaque carte, icônes dégradées, badges colorés (durée, photos, problèmes signalés)",
      "Navigation bureau et technicien : barre translucide avec effet de flou (backdrop-blur) sur fond dégradé",
      "Recherches technicien (Mes Recherches) : barre de statut colorée (violet pour Brouillon, bleu→violet pour Active, orange pour Traitée) et fond blanc uniforme pour toutes les cartes"
    ],
    corrections: [
      "Fix des clés React dupliquées dans le planning après déplacement d'une journée d'une mission longue (bug provoquant un affichage complètement cassé)",
      "Fix de la duplication des schedules dans l'état local : l'ajout optimiste après création ne duplique plus les entrées déjà insérées via Supabase Realtime",
      "Suppression du badge 'Créé avec une logique terrain' sur la page d'accueil"
    ],
    enCours: []
  },
  {
    version: "0.5.1",
    date: "2026-05-27",
    nouveautes: [
      "Compte-rendu chantier : accès dédié pour le chef d'équipe sur ses missions (terminées, en cours, en pause, partielles)",
      "Upload de photos sur les comptes-rendus de mission (MED-001) avec prévisualisation",
      "Interface mobile : sélecteur de type de recherche et boutons d'action repensés pour les petits écrans"
    ],
    ameliorations: [
      "Détection des chevauchements de planning compatible avec les dates en chaîne ISO",
      "Remontée des erreurs côté planning : message détaillé en toast au lieu d'une fermeture silencieuse du modal",
      "Affichage du compteur de brouillons en attente sur le sélecteur de recherche"
    ],
    corrections: [
      "Fix erreur 500 silencieuse lors de la planification d'un chantier depuis un devis (isoformat sur date string)",
      "Fix Compte-Rendu Chantier vide pour les chefs d'équipe : retrait des colonnes inexistantes (title, location, client_contact) dans la requête /planning/my-missions",
      "Fix du bug de report (postpone) : les schedules virtuels héritent du statut sécurisé du parent",
      "Récupération automatique des schedules parents référencés par les overrides de report"
    ],
    enCours: []
  },
  {
    version: "0.5.0",
    date: "2026-04-02",
    nouveautes: [
      "Vue détail chantier : clic sur une carte chantier pour consulter toutes les informations sans passer par Modifier",
      "Affichage de l'équipe assignée (collaborateurs + chefs d'équipe) dans le détail du chantier",
      "Sélecteur d'équipe complet dans Modifier le Chantier : choix par équipe entière ou par collaborateur individuel",
      "Assignation multi-techniciens sur les plannings (round-robin sur les schedules)"
    ],
    ameliorations: [
      "L'API /collaborators retourne désormais les noms et prénoms (plus seulement les emails)",
      "Les cartes chantier sont cliquables dans les deux vues (Chantiers et Devis/Chantiers)",
      "Bouton Modifier accessible directement depuis le modal de détail"
    ],
    corrections: [
      "Correction du PUT /worksites qui n'assignait que le premier technicien au lieu de tous",
    ],
    enCours: []
  },
  {
    version: "0.4.0",
    date: "2026-03-30",
    nouveautes: [
      "Planning Timeline : nouvelle vue avec les équipes à gauche et les missions par jour à droite",
      "Missions non assignées (UNASSIGNED) visibles et assignables dans le planning",
      "Création unifiée Chantier + Planning : les schedules sont créés automatiquement à la création d'un chantier",
      "Système de pause chantier avancé avec table planning_overrides et motifs détaillés",
      "Annotateur d'images intégré (ImageAnnotator) pour marquer les photos de chantier"
    ],
    ameliorations: [
      "Correction des débordements des cartes missions sur les jours adjacents dans le planning (overflow CSS)",
      "Optimisation des performances : audit complet et mise en cache côté frontend",
      "Chargement paresseux des données, skeleton loading et cache API",
      "Vue planning responsive avec colonnes jour correctement contraintes"
    ],
    corrections: [
      "Correction de toutes les références à la colonne 'date' remplacées par 'start_date' dans le planning",
      "Fix de la régression du chargement du planning après migration",
      "Correction du bug d'affichage des photos dans le module chantier",
      "Fix des chevauchements dans le planning (overlap detection)"
    ],
    enCours: []
  },
  {
    version: "0.3.3",
    date: "2026-03-15",
    nouveautes: [
      "Module Gestion des Équipes : chefs d'équipe avec drag & drop des collaborateurs",
      "Planning hebdomadaire et mensuel avec vue par équipe",
      "Filtre par statut sur la liste des chantiers (Tous / Planifiés / En cours / Terminés)"
    ],
    ameliorations: [
      "Audit de scalabilité complet : identification des goulots d'étranglement API et frontend",
      "Amélioration des endpoints backend avec pagination et filtres côté serveur",
      "Refonte de la navigation et du routage de l'application"
    ],
    corrections: [
      "Correction des problèmes de chargement concurrent des données",
      "Fix de la synchronisation temps réel (Supabase Realtime) pour les devis et chantiers"
    ],
    enCours: []
  },
  {
    version: "0.3.2",
    date: "2026-03-08",
    nouveautes: [
      "Ajout du journal des mises à jour pour suivre l'évolution de SkyApp",
      "Nouvel encart sur l'écran d'accueil pour consulter les dernières nouveautés"
    ],
    ameliorations: [
      "Amélioration de la lisibilité des avancées produit pour les partenaires",
      "Structuration du suivi des évolutions dans une page dédiée"
    ],
    corrections: [],
    enCours: [
      "Finalisation de la présentation des mises à jour dans l'application"
    ]
  },
  {
    version: "0.3.1",
    date: "2026-03-06",
    nouveautes: [
      "Préparation du téléchargement PDF des devis",
      "Ajout d'un indicateur de chargement lors du téléchargement d'un devis"
    ],
    ameliorations: [
      "Ajout d'un loader visible pendant les actions importantes (enregistrement, upload, génération PDF)",
      "Amélioration de la stabilité de l'interface pendant les traitements longs"
    ],
    corrections: [
      "Correction du comportement lors de clics répétés sur Enregistrer pour éviter les doublons ou blocages",
      "Correction de l'encodage des caractères spéciaux dans les PDF générés"
    ],
    enCours: [
      "Finalisation du téléchargement des devis au format PDF"
    ]
  },
  {
    version: "0.3.0",
    date: "2026-03-03",
    nouveautes: [
      "Mise en place de la validation des rôles et permissions sur l'ensemble de l'application"
    ],
    ameliorations: [
      "Vérification des accès pour les profils Administrateur, Bureau et Technicien",
      "Contrôle renforcé des accès directs par URL pour les pages protégées",
      "Amélioration de la gestion de session après rafraîchissement de page",
      "Détection automatique de la perte de session avec redirection vers la connexion"
    ],
    corrections: [
      "Correction de plusieurs points liés aux accès non autorisés",
      "Prise en compte de la suppression douce (soft delete) sur les devis dans la logique métier",
      "Correction du chargement infini sur les pages protégées lorsque la session a expiré"
    ],
    enCours: [
      "Poursuite des tests de sécurité multi-entreprises (cross-tenant)",
      "Renforcement des règles de sécurité Supabase (RLS)"
    ]
  },
  {
    version: "0.2.9",
    date: "2026-02-26",
    nouveautes: [
      "Module inventaire accessible depuis l'espace technicien"
    ],
    ameliorations: [
      "Amélioration globale de la stabilité de l'application",
      "Optimisation de la synchronisation multi-onglets pour la déconnexion"
    ],
    corrections: [
      "Correction des appels API du module matériel et inventaire (erreurs 401)",
      "Correction de l'injection du token d'authentification sur l'ensemble des requêtes"
    ],
    enCours: [
      "Tests approfondis des permissions par rôle",
      "Préparation de la génération PDF des devis"
    ]
  }
];

export default changelog;
